import { useState } from "react";
import { createContext } from "react";
import { useDispatch } from "react-redux";

import {
  setLoadingFalseAction,
  setLoadingTrueAction,
} from "../../../redux/actions/loadingActions/loadingActions";
import { toastErrorMessage } from "../../../utils/toastMessage/toastMessage";
import {
  createMenuAdminService,
  deleteMenuAdminService,
  editMenuAdminService,
  getMenusAdminService,
  getSubCategoriesAdminService,
} from "../../../services/adminServices";

export const menuAdminContext = createContext({
  image: "",
  setImage: () => {},
  title: "",
  setTitle: () => {},
  description: "",
  setDescription: () => {},
  price: "",
  setPrice: () => {},
  subCategoryId: "",
  setSubCategoryId: () => {},
  menuId: "",
  setMenuId: () => {},
  menus: [],
  setMenus: () => {},
  subCategories: [],
  setSubCategories: () => {},
  isPapular: null,
  setIsPapular: () => {},
  isShowModal: null,
  setIsShowModal: () => {},
  showModal: () => {},
  closeModal: () => {},
  handleGetSubCategories: () => {},
  handleCreateMenu: () => {},
  handleGetMenus: () => {},
  handleEditMenu: () => {},
  handleDeleteMenu: () => {},
});

const MenuAdminContext = ({ children }) => {
  const dispatch = useDispatch();

  const [image, setImage] = useState("");
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [price, setPrice] = useState("");
  const [subCategoryId, setSubCategoryId] = useState("");
  const [menuId, setMenuId] = useState("");
  const [menus, setMenus] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [isPapular, setIsPapular] = useState(false);
  const [isShowModal, setIsShowModal] = useState(false);

  // Start Modal
  const showModal = (val) => {
    setIsShowModal(true);

    if (val) {
      setMenuId(val._id);
      setImage(val.image);
      setTitle(val.title);
      setDescription(val.description);
      setPrice(val.price);
      setSubCategoryId(val.subCategory?._id);
      setIsPapular(val.isPapular);
    }
  };

  const closeModal = () => {
    setIsShowModal(false);

    setImage("");
    setTitle("");
    setDescription("");
    setPrice("");
    setSubCategoryId("");
    setMenuId("");
    setIsPapular(false);
  };

  // Handle Get Sub Categories
  const handleGetSubCategories = async () => {
    const objData = {
      categoryId: "",
    };
    try {
      const { status, data } = await getSubCategoriesAdminService(objData);
      if (status === 200) {
        setSubCategories(data.result);
      }
    } catch ({ response }) {
      if (response) {
        if (response.status) {
          toastErrorMessage(response.data.resultMessage);
        }
      }
    }
  };

  // Handle Create Menu
  const handleCreateMenu = async (event) => {
    event?.preventDefault();

    const objData = {
      image,
      title,
      description,
      price,
      isPapular,
      subCategoryId,
    };

    try {
      dispatch(setLoadingTrueAction());
      const { status } = await createMenuAdminService(objData);
      if (status === 200) {
        closeModal();
        handleGetMenus();
      }
    } catch ({ response }) {
      if (response) {
        if (response.status) {
          toastErrorMessage(response.data.resultMessage);
        }
      }
      dispatch(setLoadingFalseAction());
    }
  };

  // Handle Get Menus Context
  const handleGetMenus = async (event) => {
    event?.preventDefault();

    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await getMenusAdminService();
      if (status === 200) {
        setMenus(data?.result);
      }
    } catch ({ response }) {
      if (response) {
        if (response.status) {
          toastErrorMessage(response.data.resultMessage);
        }
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  // Handle Edit Menu
  const handleEditMenu = async (event) => {
    event?.preventDefault();

    const objData = {
      id: menuId,
      image,
      title,
      description,
      price,
      isPapular,
      subCategoryId,
    };

    try {
      dispatch(setLoadingTrueAction());
      const { status } = await editMenuAdminService(objData);
      if (status === 200) {
        closeModal();
        handleGetMenus();
      }
    } catch ({ response }) {
      if (response) {
        if (response.status) {
          toastErrorMessage(response.data.resultMessage);
        }
      }
      dispatch(setLoadingFalseAction());
    }
  };

  // Handle Delete Menu
  const handleDeleteMenu = async (id) => {
    try {
      dispatch(setLoadingTrueAction());
      const { status } = await deleteMenuAdminService(id);
      if (status === 200) {
        handleGetMenus();
      }
    } catch ({ response }) {
      if (response) {
        if (response.status) {
          toastErrorMessage(response.data.resultMessage);
        }
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  return (
    <>
      <menuAdminContext.Provider
        value={{
          image,
          setImage,
          title,
          setTitle,
          description,
          setDescription,
          price,
          setPrice,
          subCategoryId,
          setSubCategoryId,
          menuId,
          setMenuId,
          menus,
          setMenus,
          subCategories,
          setSubCategories,
          isPapular,
          setIsPapular,
          isShowModal,
          setIsShowModal,
          showModal,
          closeModal,
          handleGetSubCategories,
          handleCreateMenu,
          handleGetMenus,
          handleEditMenu,
          handleDeleteMenu,
        }}
      >
        {children}
      </menuAdminContext.Provider>
    </>
  );
};

export default MenuAdminContext;
